<template>
    <div class="contentQuesito">
        <ul class="sliceWrapper animated">
            <li v-for="i in quesito">
                <div>
                    {{checkCorrectCategory}}
                    <div class="slice" v-if="quesito[i.number].show === true"></div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>


    import {db} from '../firebaseConfig'
    import {Trans} from '../plugins/Translation'
    let varGame = db.ref('varGame');


    import guanyarQuesitoSound from '../Sounds/guanya quesito_2.wav'
    import guanyarPartidaSound from '../Sounds/guanya partida.mp3'

    export default {
        name: "Quesito",
        props: {
            categoryNumber: Number,
            sumCategory: Boolean
        },
        data() {
            return {
                messageWinCategory: '',
                contador: 0,
                category: '',
                CuesXifres: [10, 35, 75, 104, 106, 112],
                Documents: [5, 60, 70, 99, 101, 107],
                Empadronament: [15, 40, 80, 109, 111, 117],
                Estrangeria: [20, 45, 85, 92, 114, 116],
                censElectoral: [25, 50, 90, 91, 97, 119],
                Territori: [30, 55, 65, 94, 96, 102],
                Empty: [93, 98, 103, 108, 113, 118],
                categoryCheese: [120, 95, 100, 105, 110, 115],
                quesito: [
                    {
                        number: 0,
                        show: false,
                        category: "Cues i Xifres"
                    },
                    {
                        number: 1,
                        show: false,
                        category: "Documents"

                    },
                    {
                        number: 2,
                        show: false,
                        category: "Empadronament"

                    },
                    {
                        number: 3,
                        show: false,
                        category: "Estrangeria"

                    },
                    {
                        number: 4,
                        show: false,
                        category: "Cens electoral"

                    },
                    {
                        number: 5,
                        show: false,
                        category: "Territori"

                    }
                ],
                probabilityNumber: null
            }
        },
        created() {
            varGame.child('probability').on('value', snap => this.probabilityNumber = (snap.val() / 10));
        },
        methods: {

        },
        computed: {
            checkCorrectCategory() {
                let animar = false;

                let numberRandom = Math.floor(Math.random() * 10) + 1;

                //sha de cumplir la condicio de respondre bé a la pregunta

                if (this.sumCategory === true) {
                    if (numberRandom <= this.probabilityNumber) {
                        //mostrar alert
                        let showAlert = false;

                        for (let j = 0; j < this.CuesXifres.length; j++) {
                            if (this.categoryNumber === this.CuesXifres[j]) {
                                this.category = "Cues i Xifres";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;
                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.Documents.length; j++) {
                            if (this.categoryNumber === this.Documents[j]) {
                                this.category = "Documents";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.Empadronament.length; j++) {
                            if (this.categoryNumber === this.Empadronament[j]) {
                                this.category = "Empadronament";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.Estrangeria.length; j++) {
                            if (this.categoryNumber === this.Estrangeria[j]) {
                                this.category = "Estrangeria";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.censElectoral.length; j++) {
                            if (this.categoryNumber === this.censElectoral[j]) {
                                this.category = "Cens electoral";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.Territori.length; j++) {
                            if (this.categoryNumber === this.Territori[j]) {
                                this.category = "Territori";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }

                        let textAlertWinQuesito = "";

                        if (Trans.currentLanguage === 'cat') {
                            textAlertWinQuesito = "Has guanyat el formatget de la categoria " + this.category;
                        } else if (Trans.currentLanguage === 'es') {
                            textAlertWinQuesito = "Has ganado el quesito de la categoria " + this.category;
                        }

                        if (showAlert === true) {
                            this.$store.commit('newMessageWinCategory', textAlertWinQuesito);
                            this.$store.commit('showMessageWinCategoryTrue');
                            setTimeout(() => {
                                this.$store.commit('showMessageWinCategoryFalse');
                            }, 3000);
                        }

                    }
                    //CATEGORIES PUNTES
                    for (let j = 0; j < this.categoryCheese.length; j++) {
                        //mostrar alert
                        let showAlert = false;
                        if (this.categoryNumber === this.categoryCheese[j]) {
                            if (this.categoryNumber === 120) {
                                this.category = "Cues i Xifres";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                            if (this.categoryNumber === 95) {
                                this.category = "Empadronament";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                            if (this.categoryNumber === 100) {
                                this.category = "Estrangeria";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                            if (this.categoryNumber === 105) {
                                this.category = "Cens electoral";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                            if (this.categoryNumber === 110) {
                                this.category = "Territori";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                            if (this.categoryNumber === 115) {
                                this.category = "Documents";
                                for (let i = 0; i < this.quesito.length; i++) {
                                    if (this.quesito[i].category === this.category && this.quesito[i].show === false) {
                                        this.quesito[i].show = true;
                                        animar = true;
                                        showAlert = true;
                                        this.contador += 1;

                                    }
                                }
                            }
                        }

                        let textAlertWinQuesito = "";

                        if (Trans.currentLanguage === 'cat') {
                            textAlertWinQuesito = "Has guanyat el formatget de la categoria " + this.category;
                        } else if (Trans.currentLanguage === 'es') {
                            textAlertWinQuesito = "Has ganado el quesito de la categoria " + this.category;
                        }

                        if (showAlert === true) {
                            this.$store.commit('newMessageWinCategory', textAlertWinQuesito);
                            this.$store.commit('showMessageWinCategoryTrue');
                            setTimeout(() => {
                                this.$store.commit('showMessageWinCategoryFalse');
                            }, 3000);
                        }

                    }

                }

                //animar
                if (animar === true) {
                    //sound
                    let guanyarQuesitoSong = new Audio(guanyarQuesitoSound);
                    guanyarQuesitoSong.play();

                    let elem = document.querySelector('.sliceWrapper');
                    if (!elem.classList.contains('flip')) {
                        elem.classList.add('flip')
                    }
                    setTimeout(() => {
                        elem.classList.remove('flip')
                    }, 2000)
                }


                if (this.quesito[0].show === true && this.quesito[1].show === true && this.quesito[2].show === true
                    && this.quesito[3].show === true && this.quesito[4].show === true && this.quesito[5].show === true) {

                    //sound
                    let guanyarPartidaSong = new Audio(guanyarPartidaSound);
                    guanyarPartidaSong.play();

                    setTimeout(() => {
                        this.$store.commit('finishGameTrue');this.$store.commit('finishGameTrue');
                    },100);

                }
            }
        }
    }

</script>

<style lang="scss">

    .contentQuesito {
        width: 33%;
        height: 33%;
    }

    .sliceWrapper {
        position: absolute;
        margin-left: 5%;
        padding: 0;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        list-style: none;
        overflow: hidden;
        box-shadow: 2px 2px 50px rgba(0, 0, 0, 0.2);
        border: 10px solid whitesmoke;
        background: gainsboro;
        z-index: 0;
    }

    .slice {
        position: absolute;
        left: -100%;
        width: 200%;
        height: 200%;
        z-index: 0;
    }

    li {
        overflow: hidden;
        position: absolute;
        top: -50%;
        right: -50%;
        width: 100%;
        height: 100%;
        transform-origin: 0% 100%;
        border: 3px solid whitesmoke;
        /*box-shadow: 2px 2px 50px rgba(0, 0, 0, 0.2);*/
        background: gainsboro;
        z-index: 2;
    }

    li:first-child {
        transform: rotate(60deg) skewY(-30deg);
    }

    li:nth-child(2) {
        transform: rotate(120deg) skewY(-30deg);
    }

    li:nth-child(3) {
        transform: rotate(180deg) skewY(-30deg);
    }

    li:nth-child(4) {
        transform: rotate(240deg) skewY(-30deg);
    }

    li:nth-child(5) {
        transform: rotate(300deg) skewY(-30deg);
    }

    li:nth-child(6) {
        transform: rotate(360deg) skewY(-30deg);
    }

    li:first-child .slice {
        background-color: #B78DE4;

        &:hover {
            background: gray;
        }
    }

    li:nth-child(2) .slice {
        background-color: #FCE15C;

        &:hover {
            background: gray;
        }
    }

    li:nth-child(3) .slice {
        background-color: #FF7BA3;

        &:hover {
            background: gray;
        }
    }

    li:nth-child(4) .slice {
        background-color: #2dde98;

        &:hover {
            background: gray;
        }
    }

    li:nth-child(5) .slice {
        background-color: #F5DABD;

        &:hover {
            background: gray;
        }
    }

    li:nth-child(6) .slice {
        background-color: #ffc2e5;

        &:hover {
            background: gray;
        }
    }

    //Adaptara movil
    @media only screen and (max-width: 720px) {
        .sliceWrapper {
            width: 100px;
            height: 100px;
        }

    }

</style>
